import axios from 'axios';
import config from '../config';

const DashboardService = {
  getMetrics: async () => {
    try {
      const response = await axios.get(`${config.apiBaseUrl}/dashboard/metrics`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard metrics:', error);
      throw error;
    }
  },
};

export default DashboardService;
